(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-panel-tipsen/assets/javascripts/utils/get-game-icon-by-type.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-panel-tipsen/assets/javascripts/utils/get-game-icon-by-type.js');
"use strict";


const {
  SportTypes
} = svs.components.sport.sportTypes;
const getGameIconByType = sportType => {
  switch (sportType) {
    case SportTypes.Soccer:
      return 'game-soccer';
    case SportTypes.Hockey:
      return 'game-hockey';
    default:
      return 'games';
  }
};
setGlobal('svs.components.tipsen.drawPanelTipsen.utils.getGameIconByType', getGameIconByType);

 })(window);